import React from 'react';
import { authPages, dashboardMenu, demoPages, othersMenu, publicPages } from '../menu';
import DashboardHeader from '../pages/common/Headers/DashboardHeader';

const headers = [
  // { path: layoutMenu.pageLayout.subMenu.onlySubheader.path, element: null, exact: true },
  // { path: layoutMenu.pageLayout.subMenu.onlyContent.path, element: null, exact: true },
  // { path: layoutMenu.blank.path, element: null, exact: true },
  { path: authPages.login.path, element: null, exact: true },
  { path: othersMenu.monitor_login.path, element: null, exact: true },
  { path: othersMenu.orderMonitor.path, element: null, exact: true },
  { path: publicPages.evaluation.path, element: null, exact: true },
  { path: publicPages.clientRegister.path, element: null, exact: true },
  { path: othersMenu.resetPassword.path, element: null, exact: true },
  { path: authPages.signUp.path, element: null, exact: true },
  { path: authPages.page404.path, element: null, exact: true },
  { path: dashboardMenu.dashboard.path, element: <DashboardHeader />, exact: true },
  ...Object.keys(demoPages.pageLayout.subMenu).map(key => ({
    path: demoPages.pageLayout.subMenu[key].path, element: <DashboardHeader />, exact: true
  })),
  ...Object.keys(demoPages.pdvMenu.subMenu).map(key => ({
    path: demoPages.pdvMenu.subMenu[key].path, element: <DashboardHeader />, exact: true
  })),
  ...Object.keys(demoPages.pdvLoja.subMenu).map(key => ({
    path: demoPages.pdvLoja.subMenu[key].path, element: <DashboardHeader />, exact: true
  })),
  ...Object.keys(demoPages.subscription.subMenu).map(key => ({
    path: demoPages.subscription.subMenu[key].path, element: <DashboardHeader />, exact: true
  })),

  ...Object.keys(demoPages.subscription.subMenu.matriz).map(key => ({
    path: demoPages.subscription.subMenu.matriz[key].path, element: <DashboardHeader />, exact: true
  })),

  ...Object.keys(demoPages.subscription.subMenu.signature).map(key => ({
    path: demoPages.subscription.subMenu.signature[key].path, element: <DashboardHeader />, exact: true
  })),
  ...Object.keys(demoPages.fiscal.subMenu).map(key => ({
    path: demoPages.fiscal.subMenu[key].path, element: <DashboardHeader />, exact: true
  })),
  ...Object.keys(demoPages.store.subMenu).map(key => ({
    path: demoPages.store.subMenu[key].path, element: <DashboardHeader />, exact: true
  })),
  ...Object.keys(demoPages.command.subMenu).map(key => ({
    path: demoPages.command.subMenu[key].path, element: <DashboardHeader />, exact: true
  })),
  ...Object.keys(demoPages.reports.subMenu).map(key => ({
    path: demoPages.reports.subMenu[key].path, element: <DashboardHeader />, exact: true
  })),
  ...Object.keys(demoPages.delivery.subMenu).map(key => ({
    path: demoPages.delivery.subMenu[key].path, element: <DashboardHeader />, exact: true
  })),
  ...Object.keys(demoPages.integracoes.subMenu).map(key => ({
    path: demoPages.integracoes.subMenu[key].path, element: <DashboardHeader />, exact: true
  })),
  // { path: demoPages.notifications.path, element: <DashboardHeader />, exact: true },
  // { path: demoPages.contactUs.path, element: <DashboardHeader />, exact: true },
  { path: authPages.profile.path, element: <DashboardHeader />, exact: true },
  { path: demoPages.settings.path, element: <DashboardHeader />, exact: true },
  { path: demoPages.billingValue.path, element: <DashboardHeader />, exact: true },


  // { path: demoPages.reports.path, element: <DashboardHeader />, exact: true },
  // { path: demoPages.documentations.path, element: <DashboardHeader />, exact: true },
  /*{
    path: `*`,
    element: <DefaultHeader />,
  },*/
];

export default headers;
